import script from "./AdministrationExpenses.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministrationExpenses.vue?vue&type=script&setup=true&lang=js"

import "./AdministrationExpenses.vue?vue&type=style&index=0&id=def9bb60&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-def9bb60"]])

export default __exports__